import React, { ReactElement } from 'react';
import { Circle } from 'rc-progress';
import styled, { useTheme } from 'styled-components';
import { useSchool } from 'features/school';

const ProgressWrapper = styled('div')`
  position: relative;
  margin: 0 auto;

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 200px;
      height: 200px;
      
      ${mediaQueries.desktop} {
        width: 300px;
        height: 300px;
      }
    `;
  }}
`;

const ProgressPercentage = styled('div')<{ color: string }>`
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  font-weight: ${({ theme }) => theme.fontWeights.light};
  color: ${({ color }) => color};

  span {
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  ${({ theme: { mediaQueries } }) => {
    return `
    font-size: 3.75rem;
    letter-spacing: -3px;

        span {
          font-size: 1.80rem;
        }

    ${mediaQueries.desktop} {
      font-size: 7.2rem;
      letter-spacing: -5px;

      span {
        font-size: 3.75rem;
      }
    }
  `;
  }}
`;

const ProgressLabel = styled('div')`
  display: inline-block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 400;
  text-align: center;
  line-height: 1;
  color: ${({ theme }) => theme.colors.gray_500};

  ${({ theme: { mediaQueries } }) => {
    return `
    font-size: 1rem;
    bottom: 0;

    ${mediaQueries.desktop} {
      font-size: 1.45rem;
      bottom: 10px;
    }
  `;
  }}
`;

interface ProgressProps {
  percent: number;
}

const Progress = ({ percent = 0 }: ProgressProps): ReactElement => {
  const { colors } = useTheme();

  const { schoolAlias } = useSchool();

  let percentage = percent;
  if (percentage < 0) percentage = 0;
  if (percentage > 100) percentage = 100;

  const schoolColor = schoolAlias === 'b3' ? colors.secondary_400 : colors.primary_400;

  return (
    <ProgressWrapper>
      <ProgressPercentage color={schoolColor}>
        {Math.round(Number(percentage))}
        <span>%</span>
      </ProgressPercentage>

      <Circle
        percent={percentage}
        gapDegree={70}
        gapPosition="bottom"
        strokeWidth={4}
        trailWidth={4}
        strokeLinecap="round"
        strokeColor={[schoolColor, colors.gray_200]}
      />

      <ProgressLabel>das atividades concluídas</ProgressLabel>
    </ProgressWrapper>
  );
};

export default Progress;
